module.exports = __webpack_public_path__ + "media/images/abranda-53063373eece07a9d4d92170491f21d5.png";